require('./_set-species')('Array');



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/es6.array.species.js
 ** module id = 192
 ** module chunks = 0
 **/